<template>
  <div class="newsInformation">
    <detailsTop />
    <div class="news-content">
      <div class="new-left"></div>
      <div class="new-center">

        <div class="new-article">
          <div class="article-title">{{noticeInfo.title}}</div>

          <div class="new-operate">

            <div class="operate-left">
              <i class="el-icon-time" style="font-size: 18px;color: #BFBFBF;"></i>
              <span style="color: #BFBFBF; margin-left: 2%;">{{noticeInfo.createTime}}</span>
            </div>

            <div class="operate-right">
              <el-image class="operate-img" :src="require('@/assets/images/A+.png')" @click="typeface('+')"></el-image>
              <el-image class="operate-img" :src="require('@/assets/images/A-.png')" @click="typeface('-')"></el-image>
              <el-image class="operate-img" :src="require('@/assets/images/A.png')" @click="typeface('A')"></el-image>

            </div>
          </div>

          <div v-html="noticeInfo.content" class="operate-content" ref="operateSizeRef" id="operate-content">

          </div>

        </div>
      </div>
      <div class="new-right"></div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from '@/components/detailsTop.vue'
import pageBottom from '@/components/pageBottom'
import { getTNoticeInfo } from '@/api/api.js'

export default {
  name: 'news',
  components: {
    detailsTop,
    pageBottom
  },
  data () {
    return {
      noticeId: null,
      projectTypeParentId: null,
      noticeInfo: {}

    }
  },
  created () {
    this.noticeId = this.$route.query.id
    this.getNewInfo()
  },
  methods: {
    async getNewInfo () {
      const { data } = await getTNoticeInfo({ noticeId: this.noticeId })
      this.noticeInfo = data.data
    },
  
    typeface (item) {
      var allp = document.getElementsByTagName('p')
      var num = allp[0].style.fontSize.substring(0, 2) ? allp[0].style.fontSize.substring(0, 2) : 16
      switch (item) {
        case '+':
          for (const item of allp) {
            item.style.fontSize = (Number(num) + 1) + 'px'
          }
          break
        case '-':
          for (const item of allp) {
            item.style.fontSize = (Number(num) - 1) + 'px'
          }
          break
        case 'A':
          // this.$refs.operateSizeRef.style.fontSize = '16px'
          for (const item of allp) {
            item.style.fontSize = 16 + 'px'
          }
          break
      }
    }

  }
}
</script>

<style scoped lang="less">

.news-content {
  margin-top: 20px;
  width: 100%;
  height: 100%;
  display: flex;

  .new-left {
    flex: 1;
  }

  .new-center {
    flex: 5.3;
    background: #F4F4F4;
    min-height:500px;

    .new-article {
      margin-top: 22px;
      background: #FFFFFF;
      width: 100%;
      padding-top: 2%;
      min-height: 400px;

      .article-title {
        width: 860px;
        font-weight: bold;
        font-size: 26px;
        color: #C10203;
        margin: 0 auto;
        line-height: 55px;
      }

      .new-operate {
        width: 80%;
        margin: 32px auto;
        height: 43px;
        line-height: 43px;
        border-top: 1px solid #EEEEEE;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .operate-left {
          margin-left: 6%;
          width: 180px;
        }

        .operate-right {
          margin-right: 7%;
          width: 13%;
          display: flex;
          justify-content: space-around;

          .operate-img {
            width: 28px;
            height: 28px;
            cursor: pointer;
          }

        }
      }

      .operate-content {
        width: 80%;
        margin: 32px auto;
        color: #515151;
        font-size: 16px;
        font-weight: 400;
        line-height: 42px;
        text-align: left;
        // text-indent: 2em;
        display: flex;
        flex-direction: column;
        align-items: center;

     }

    }

    .pagination {
      margin: 4% auto;
    }
  }

  .new-right {
    flex: 1;
    // background: sandybrown;

  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #FFF;
  }
}

@media only screen and (max-width: 1550px) {
  .new-left {
    flex: 1 !important;
  }

  .new-center {
    flex: 12 !important;
    background: #F4F4F4;
  }

  .new-right {
    flex: 1 !important;
  }
}</style>

<style lang="less" >
.operate-content{
  img {
  width: 100%;
}
}

</style>
